if($('header#header').length){
    $('nav#navigation .navigationActions').append($('.top-navigation-bar-menu li').clone())
    $('.responsive-tools').append('<div id="dkLabFavHeaderWrapper"><a href="/oblibene/" class="dkLabFavHeaderIconBtn" id="dkLabFavHeaderIconBtn"></a></div>')
    if($('.breadcrumbs').length){
        if($('.breadcrumbs span#navigation-1  meta[itemprop="item"]').length>0){
            var url = $('.breadcrumbs span#navigation-1 meta[itemprop="item"]').attr('content');
        }
        else{
            var url = $('.breadcrumbs span#navigation-1 a').attr('href');
        }
        if (url) {
            let relativeUrl = url.replace(/^https?:\/\/[^/]+/, '');
            relativeUrl = relativeUrl.replace(/^\/\/[^/]+/, '');
            console.log(relativeUrl)
            $('nav#navigation ul.menu-level-1>li>a[href="'+relativeUrl+'"]').addClass('activeLink')
        }
    }
    $('.responsive-tools').prepend($('.top-navigation-tools .dropdown').clone())
    $('header#header .header-top').append($('.top-navigation-contacts'))
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo('.responsive-tools');
    if($('a.top-nav-button-login.login').length>0){
        $('.responsive-tools').append('<div class="customLoginRegistration"><a href="#" class="toggle-window" data-target="login">Přihlášení</a><a href="/registrace/">Nová registrace</a></div>')
    }
    else{
        $('.responsive-tools').append('<div class="customLoginRegistration"><a href="'+$('.top-nav-button-account').attr('href')+'">'+$('.top-nav-button-account').text()+'</a></div>')
    }
    
    
    $('.header-top').append($('.top-navigation-bar .responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', 'E-mailová adresa')//.before('<label for="email">Uživatelské jméno nebo e-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', 'Heslo')//.before('<label for="password">Heslo<span>*</span></label>');
    $('#customerLogin .password-helper a[data-testid="signup"]').before('<div class="ucet">Ještě nemáte účet? <a href="'+$('a[data-testid="signup"]').attr('href')+'" rel="nofollow" data-testid="signup">Zaregistrujte se</a></div>')
    $('#customerLogin .input-wrapper.password').append($('.login-wrapper .password-helper a:not([data-testid="signup"])'));
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner'); 
    $('nav#navigation .menu-image img').each(function(){
        if($(this).attr('data-src')){
            $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
            $(this).attr('src', $(this).attr('data-src'))
        }
       
    })
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
    
    $(document).ready(function(){
        $('#formSearchForm div.search-whisperer').after('<span class="searchClose"></span>')
    })
    $(document).on('click', '.searchClose', function(){
        $('body').removeClass('search-focused')
        $('.search-whisperer').removeClass('active').html('')
        $('input[type="search"]').val('')
        $('body').removeClass('user-action-visible, search-window-visible')
    })
    $('.login-widget #customerLogin').append($('.login-widget #customerLogin .social-login-buttons'))
}